import { ComponentProps } from 'react';
import { NumericFormat } from 'react-number-format';
import { input } from '../../patterns/input';

const PREFIX = '€ ';

type Props = {
  size?: 'default' | 'large';
  placeholder?: number;
  onChange: (value: number) => void;
} & Omit<
  ComponentProps<typeof NumericFormat>,
  'size' | 'onValueChange' | 'onChange'
>;

export function ValutaInput(props: Props) {
  const { placeholder, onChange, value } = props;

  return (
    <NumericFormat
      prefix={PREFIX}
      className={input()}
      placeholder={placeholder ? `${PREFIX}${placeholder}` : PREFIX}
      decimalScale={2}
      decimalSeparator=","
      thousandSeparator="."
      allowNegative={false}
      onValueChange={(event) => onChange(event.floatValue ?? 0)}
      value={value}
    />
  );
}
